import { render, staticRenderFns } from "./IndexKasKecil.vue?vue&type=template&id=133e5dfb&"
import script from "./IndexKasKecil.vue?vue&type=script&lang=js&"
export * from "./IndexKasKecil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports